var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlagRu = function SvgFlagRu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_35456_19315",
    width: 23,
    height: 22,
    x: 1,
    y: 1,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.3945,
    cy: 12,
    r: 11,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_35456_19315)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M23.3945 8.3H1.39453V1.6C1.39453 1.3 1.59453 1 1.79453 1H22.9945C23.1945 1 23.3945 1.3 23.3945 1.6V8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#41479B",
    d: "M23.3945 8.2998H1.39453V15.5998H23.3945V8.2998Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4B55",
    d: "M22.9945 22.9996H1.79453C1.59453 22.9996 1.39453 22.6996 1.39453 22.3996V15.5996H23.3945V22.3996C23.3945 22.6996 23.1945 22.9996 22.9945 22.9996Z"
  }))));
};
export default SvgFlagRu;